import { useContext } from 'react';
import { LastVisitedRouteContext } from '@/contexts/last-visited-route-context';
export function useLastVisitedRoute() {
  const context = useContext(LastVisitedRouteContext);
  if (!context) {
    throw new Error("useLastVisitedRoute deve ser usado dentro de um LastVisitedRouteProvider");
  }
  return context;
}